import { setSubroute } from 'store/navbar'
import { injectReducer } from 'store/reducers'
import { setPageTitle } from 'utils/misc'
import { UserHasValidPassword, UserIsAuthenticated, UserHasScope } from 'containers/authContainers'
import DataCorrectionContainer from './containers/DataCorrectionContainer'
import reducer from './modules/DataCorrection'

export default store => {
  injectReducer(store, {
    key: 'dataCorrection',
    reducer,
  })

  const dataCorrectionPageRoute = {
    getComponent(nextState, cb) {
      const { params } = nextState
      const { studyID } = params
      const state = store.getState()
      setPageTitle(`Data Correction | Study ${studyID} | ${state.study.currentStudy.platform_name}`)

      require.ensure(
        [],
        () => {
          cb(
            null,
            UserIsAuthenticated(
              UserHasValidPassword(UserHasScope(['xf'], DataCorrectionContainer, false, studyID)),
            ),
          )
        },
        'data-correction',
      )
    },
  }

  return {
    path: 'data-correction',
    exact: true,
    indexRoute: {
      ...dataCorrectionPageRoute,
      getComponent(nextState, cb) {
        store.dispatch(setSubroute('dataCorrection'))
        dataCorrectionPageRoute.getComponent(nextState, cb)
      },
    },
  }
}
